import './MoviePage.scss'
import { MovieAbout } from '../../components/MovieAbout/MovieAbout'
import { Movie } from '../../components/Movie/Movie'

export const MoviePage = () => {

    return (
        <>
            <Movie />
            <MovieAbout />
        </>
    )
}